import classNames from 'classnames';
const sizeClassNames = (modalSize = 'medium') => {
    switch (modalSize) {
        case 'wide':
            return 'sgw-modal-dialog__wide';
        case 'large':
            return 'sgw-modal-dialog__large';
        case 'medium':
        default:
            return 'sgw-modal-dialog__medium';
    }
};
const typeClassNames = (modalType = 'standard') => {
    switch (modalType) {
        case 'sub':
            return 'sgw-modal-dialog__sub';
        case 'standard':
        default:
            return '';
    }
};
const animateClassNames = (modalTypes) => {
    if (modalTypes) {
        switch (modalTypes) {
            case 'sub':
                return 'animate-as-sub';
            case 'standard':
            default:
                return 'animate-as-standard';
        }
    }
    return null;
};
const getModalDialogClassNames = (ownProps) => {
    const modalTypeClassName = typeClassNames(ownProps.type);
    const sizeClassName = sizeClassNames(ownProps.size);
    const growClassName = ownProps.growWithContent ? 'sgw-modal-dialog__grow-with-content' : '';
    const animateAs = animateClassNames(ownProps.animateAs);
    return classNames(modalTypeClassName, sizeClassName, growClassName, animateAs);
};
export default getModalDialogClassNames;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0TW9kYWxEaWFsb2dDbGFzc05hbWVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vQGVpa2EvbW9kYWwvc3JjL3V0aWwvZ2V0TW9kYWxEaWFsb2dDbGFzc05hbWVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sVUFBVSxNQUFNLFlBQVksQ0FBQztBQUlwQyxNQUFNLGNBQWMsR0FBRyxDQUFDLFlBQThCLFFBQVEsRUFBRSxFQUFFO0lBQzlELFFBQVEsU0FBUyxFQUFFLENBQUM7UUFDaEIsS0FBSyxNQUFNO1lBQ1AsT0FBTyx3QkFBd0IsQ0FBQztRQUNwQyxLQUFLLE9BQU87WUFDUixPQUFPLHlCQUF5QixDQUFDO1FBQ3JDLEtBQUssUUFBUSxDQUFDO1FBQ2Q7WUFDSSxPQUFPLDBCQUEwQixDQUFDO0lBQzFDLENBQUM7QUFDTCxDQUFDLENBQUM7QUFFRixNQUFNLGNBQWMsR0FBRyxDQUFDLFlBQTZCLFVBQVUsRUFBRSxFQUFFO0lBQy9ELFFBQVEsU0FBUyxFQUFFLENBQUM7UUFDaEIsS0FBSyxLQUFLO1lBQ04sT0FBTyx1QkFBdUIsQ0FBQztRQUNuQyxLQUFLLFVBQVUsQ0FBQztRQUNoQjtZQUNJLE9BQU8sRUFBRSxDQUFDO0lBQ2xCLENBQUM7QUFDTCxDQUFDLENBQUM7QUFFRixNQUFNLGlCQUFpQixHQUFHLENBQUMsVUFBNEIsRUFBaUIsRUFBRTtJQUN0RSxJQUFJLFVBQVUsRUFBRSxDQUFDO1FBQ2IsUUFBUSxVQUFVLEVBQUUsQ0FBQztZQUNqQixLQUFLLEtBQUs7Z0JBQ04sT0FBTyxnQkFBZ0IsQ0FBQztZQUM1QixLQUFLLFVBQVUsQ0FBQztZQUNoQjtnQkFDSSxPQUFPLHFCQUFxQixDQUFDO1FBQ3JDLENBQUM7SUFDTCxDQUFDO0lBQ0QsT0FBTyxJQUFJLENBQUM7QUFDaEIsQ0FBQyxDQUFDO0FBRUYsTUFBTSx3QkFBd0IsR0FBRyxDQUFDLFFBQTBCLEVBQUUsRUFBRTtJQUM1RCxNQUFNLGtCQUFrQixHQUFHLGNBQWMsQ0FBQyxRQUFRLENBQUMsSUFBSSxDQUFDLENBQUM7SUFDekQsTUFBTSxhQUFhLEdBQUcsY0FBYyxDQUFDLFFBQVEsQ0FBQyxJQUFJLENBQUMsQ0FBQztJQUNwRCxNQUFNLGFBQWEsR0FBRyxRQUFRLENBQUMsZUFBZSxDQUFDLENBQUMsQ0FBQyxxQ0FBcUMsQ0FBQyxDQUFDLENBQUMsRUFBRSxDQUFDO0lBQzVGLE1BQU0sU0FBUyxHQUFHLGlCQUFpQixDQUFDLFFBQVEsQ0FBQyxTQUFTLENBQUMsQ0FBQztJQUV4RCxPQUFPLFVBQVUsQ0FBQyxrQkFBa0IsRUFBRSxhQUFhLEVBQUUsYUFBYSxFQUFFLFNBQVMsQ0FBQyxDQUFDO0FBQ25GLENBQUMsQ0FBQztBQUVGLGVBQWUsd0JBQXdCLENBQUMifQ==